import type * as Types from "../../schema.generated";

import { gql } from "@apollo/client";
import { TaxDeclarationSavedDraftDataFragmentDoc } from "../../fragments/taxDeclarationSavedDraftData.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type VatAnnualDeclarationSavedDraftInfoQueryVariables = Types.Exact<{
  email: Types.Scalars["String"];
  year: Types.Scalars["Int"];
}>;

export type VatAnnualDeclarationSavedDraftInfoQuery = {
  __typename?: "Query";
  vatAnnualDeclaration: {
    __typename?: "VatAnnualDeclaration";
    savedDraftInfo?: {
      __typename?: "TaxDeclarationSavedDraftInfo";
      createdAt?: string | null;
      createdBy?: string | null;
      updatedAt?: string | null;
      pdf?: string | null;
      calculationSheet?: string | null;
      externalAssets?: Array<{
        __typename?: "TaxDeclarationExternalAsset";
        url: string;
        filetype: string;
        createdAt: string;
      }> | null;
    } | null;
  };
};

export const VatAnnualDeclarationSavedDraftInfoDocument = gql`
  query vatAnnualDeclarationSavedDraftInfo($email: String!, $year: Int!) {
    vatAnnualDeclaration(email: $email, year: $year) {
      savedDraftInfo {
        ...TaxDeclarationSavedDraftData
      }
    }
  }
  ${TaxDeclarationSavedDraftDataFragmentDoc}
`;

/**
 * __useVatAnnualDeclarationSavedDraftInfoQuery__
 *
 * To run a query within a React component, call `useVatAnnualDeclarationSavedDraftInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useVatAnnualDeclarationSavedDraftInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVatAnnualDeclarationSavedDraftInfoQuery({
 *   variables: {
 *      email: // value for 'email'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useVatAnnualDeclarationSavedDraftInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    VatAnnualDeclarationSavedDraftInfoQuery,
    VatAnnualDeclarationSavedDraftInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    VatAnnualDeclarationSavedDraftInfoQuery,
    VatAnnualDeclarationSavedDraftInfoQueryVariables
  >(VatAnnualDeclarationSavedDraftInfoDocument, options);
}
export function useVatAnnualDeclarationSavedDraftInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    VatAnnualDeclarationSavedDraftInfoQuery,
    VatAnnualDeclarationSavedDraftInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    VatAnnualDeclarationSavedDraftInfoQuery,
    VatAnnualDeclarationSavedDraftInfoQueryVariables
  >(VatAnnualDeclarationSavedDraftInfoDocument, options);
}
export type VatAnnualDeclarationSavedDraftInfoQueryHookResult = ReturnType<
  typeof useVatAnnualDeclarationSavedDraftInfoQuery
>;
export type VatAnnualDeclarationSavedDraftInfoLazyQueryHookResult = ReturnType<
  typeof useVatAnnualDeclarationSavedDraftInfoLazyQuery
>;
export type VatAnnualDeclarationSavedDraftInfoQueryResult = Apollo.QueryResult<
  VatAnnualDeclarationSavedDraftInfoQuery,
  VatAnnualDeclarationSavedDraftInfoQueryVariables
>;
